import {
    ResultObj,
    allFetch,
} from "../Domain";


/**
 * 場地預約 的欄位
 */
export type MeetingRoomParams = {
    mr_id: string
    name: string
    remark: string
    status: string
    type: string
    url_value: string
}

// 預約紀錄 查詢結果
export type MeetingRoomListResItem = {
    book_date: string
    book_time: string
    gender: string
    mr_name: string
    name: string
    remark: string
    subject: string
    type: string
    user_name: string
}

// 預約記錄查詢(依使用者) 查詢結果
export type MeetingRoomBookingListByUserFDResItem = {
    book_datetime: string
    gender: string
    mr_name: string
    mrb_id: string
    name: string
    remark: string
    subject: string
    type: string
}

// 預約記錄查詢(顯示所選日期所有預約內容)
export type MeetingRoomListByDayResItem = {
    book_date: string
    book_time: string
    cre_time: string
    mr_id: string
    mrb_id: string
    name: string
    user_cre_time: string
    user_id: string
}

// 預約記錄查詢(顯示日期是否有預約) 查詢結果
export type MeetingRoomListByMonthResItem = { days: string, found: "Y" | "N" }


export interface MeetingRoomCreateParams {
    status: string;
    type: string;
    name: string;
    remark: string;
}

/**
 * @description 新增新車庫存
 */
export const MeetingRoomCreate = async (
    obj: MeetingRoomCreateParams,
): Promise<ResultObj> => {
    return await allFetch("MeetingRoom/MeetingRoomCreate", obj);
};

export interface MeetingRoomSearchParams {
    status: string;
    type: string;
    name: string;
    remark: string;
    page: number;
    num_per_page: number;
}

/**
 * @description 場地查詢
 */
export const MeetingRoomSearch = async (
    obj: MeetingRoomSearchParams,
): Promise<ResultObj> => {
    return await allFetch("MeetingRoom/MeetingRoomSearch", obj);
};

export interface MeetingRoomDetailParams {
    mr_id: string;
}

/**
 * @description 場地細項
 */
export const MeetingRoomDetail = async (
    obj: MeetingRoomDetailParams,
): Promise<ResultObj> => {
    return await allFetch("MeetingRoom/MeetingRoomDetail", obj);
};

export interface MeetingRoomUpdateParams {
    mr_id: string;
    status: string;
    type: string;
    name: string;
    remark: string;
}

/**
 * @description 場地修改
 */
export const MeetingRoomUpdate = async (
    obj: MeetingRoomUpdateParams,
): Promise<ResultObj> => {
    return await allFetch("MeetingRoom/MeetingRoomUpdate", obj);
};

export interface MeetingRoomListByMonthParams {
    mr_id: string;
    month: string;
    user_id: string;
}

/**
 * @description 預約記錄查詢(顯示日期是否有預約)
 */
export const MeetingRoomListByMonth = async (
    obj: MeetingRoomListByMonthParams,
): Promise<ResultObj<MeetingRoomListByMonthResItem[]>> => {
    return await allFetch("MeetingRoom/MeetingRoomListByMonth", obj);
};

export interface MeetingRoomListByDayParams {
    mr_id: string;
    book_date: string;
}

/**
 * @description 預約記錄查詢(顯示所選日期所有預約內容)
 */
export const MeetingRoomListByDay = async (
    obj: MeetingRoomListByDayParams,
): Promise<ResultObj<MeetingRoomListByDayResItem[]>> => {
    return await allFetch("MeetingRoom/MeetingRoomListByDay", obj);
};

export interface MeetingRoomBookingListParams {
    type: string;
    mr_id: string;
    start_date: string;
    end_date: string;
    user_id: string;
    user_name: string;
    front_status: boolean;
    excel_status: boolean;
    [key: string]: string | boolean
}

/**
 * @description 預約記錄查詢
 */
export const MeetingRoomBookingList = async (
    obj: MeetingRoomBookingListParams,
): Promise<ResultObj<MeetingRoomListResItem[]>> => {
    return await allFetch("MeetingRoom/MeetingRoomBookingList", obj);
};

export interface MeetingRoomBookingListExportParams {
    type: string;
    mr_id: string;
    start_date: string;
    end_date: string;
    user_id: string;
    front_status: boolean;
    user_name: string;
    excel_status: boolean;
}

/**
 
@description 預約記錄查詢匯出
*/
export const MeetingRoomBookingListExport = async (obj: MeetingRoomBookingListExportParams = {
    type: '',
    mr_id: '',
    start_date: '',
    end_date: '',
    user_id: '',
    front_status: false,
    user_name: '',
    excel_status: false
}): Promise<ResultObj> => await allFetch('MeetingRoom/MeetingRoomBookingListExport', obj);

export interface MeetingRoomBookingListByUserFDParams {
    type: string,
    mr_id: string,
    start_date: string,
    end_date: string,
    user_id: string,
    front_status: boolean
}

/** 
 * @description 預約記錄查詢(依使用者)
 */
export const MeetingRoomBookingListByUserFD = async (obj: MeetingRoomBookingListByUserFDParams = {
    type: '',
    mr_id: '',
    start_date: '',
    end_date: '',
    user_id: '',
    front_status: false
}): Promise<ResultObj<MeetingRoomBookingListByUserFDResItem[]>> => await allFetch('MeetingRoom/MeetingRoomBookingListByUserFD', obj);


export interface MeetingRoomBookingCreateFDParams {
    mr_id: string,
    book_date: string,
    book_time: string,
    user_id: string,
    front_status: boolean
}

/**
 * @description 新增預約紀錄
 */
export const MeetingRoomBookingCreateFD = async (obj: MeetingRoomBookingCreateFDParams = {
    mr_id: '',
    book_date: '',
    book_time: '',
    user_id: '',
    front_status: false
}): Promise<ResultObj> => await allFetch('MeetingRoom/MeetingRoomBookingCreateFD', obj);

export interface MeetingRoomBookingAllDayCreateFDParams {
    mr_id: string,
    book_date: string,
    user_id: string,
    front_status: boolean
}
/**
 * @description 新增預約紀錄(整天)
 */
export const MeetingRoomBookingAllDayCreateFD = async (obj: MeetingRoomBookingAllDayCreateFDParams = {
    mr_id: '',
    book_date: '',
    user_id: '',
    front_status: false
}): Promise<ResultObj> => await allFetch('MeetingRoom/MeetingRoomBookingAllDayCreateFD', obj);

/**
 * @description 修改預約紀錄
 * @param {string} mrb_id_list 預約編號
 * @param {string} subject 主題
 * @param {string} name 客戶姓名
 * @param {string} gender 客戶性別
 * @param {string} remark 備註
 * @param {string} user_id 帳號編號
 * @param {boolean} front_status 是否front
 */
export interface MeetingRoomBookingUpdateFDParams {
    mrb_id_list: Array<string>
    subject: string
    name: string
    gender: string
    remark: string
    user_id: string
    front_status: boolean
}

export const MeetingRoomBookingUpdateFD = async (obj: MeetingRoomBookingUpdateFDParams = {
    mrb_id_list: [],
    subject: "",
    name: "",
    gender: "",
    remark: "",
    user_id: "",
    front_status: false,
}): Promise<ResultObj> => await allFetch('MeetingRoom/MeetingRoomBookingUpdateFD', obj);


/**
 * @description 刪除預約紀錄
 * @param {string} mr_id 編號
 * @param {string} book_date 預約日期
 * @param {string} book_time 預約時間
 * @param {string} user_id 帳號編號
 * @param {boolean} front_status 是否front
 */
export interface MeetingRoomBookingDeleteFDParams {
    mr_id: string
    book_date: string
    book_time: string
    user_id: string
    front_status: boolean
}

export const MeetingRoomBookingDeleteFD = async (obj: MeetingRoomBookingDeleteFDParams = {
    mr_id: '',
    book_date: '',
    book_time: '',
    user_id: '',
    front_status: false
}): Promise<ResultObj> => await allFetch('MeetingRoom/MeetingRoomBookingDeleteFD', obj);
